import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import CustomModal from '../../components/common/CustomModal';
import CustomInput from '../../components/common/CustomInput';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { MdOutlineClose } from 'react-icons/md';

const ChangePasswordSchema = Yup.object().shape({
  password: Yup.string() .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});

const ChangePassword = ({ isOpen, handleClose, handleSubmit, name, userId }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  return (
    <CustomModal handleCloseModal={handleClose} closeModal={!isOpen}>
      <div className="p-6">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          <MdOutlineClose size={24} />
        </button>
        <h2 className="text-2xl font-bold mb-4">Change Password for {name}</h2>
        <Formik
          initialValues={{ password: '', confirmPassword: '' }}
          validationSchema={ChangePasswordSchema}
          onSubmit={(values) => {
            handleSubmit({ ...values, userId });
          }}
        >
          {({ errors, touched }) => (
            <Form className="space-y-4">
              <div className="relative">
                <Field
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="New Password"
                  component={CustomInput}
                  label="New Password"
                  required
                />
                <button
                  type="button"
                  onClick={() => togglePasswordVisibility('password')}
                  className="absolute right-3 top-9 text-gray-400"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <div className="relative">
                <Field
                  name="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Confirm New Password"
                  component={CustomInput}
                  label="Confirm New Password"
                  required
                />
                <button
                  type="button"
                  onClick={() => togglePasswordVisibility('confirmPassword')}
                  className="absolute right-3 top-9 text-gray-400"
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-orange-600"
                >
                  Change Password
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </CustomModal>
  );
};

export default ChangePassword;

